export default (sitemap: SitemapBuilder) =>
{
    sitemap.before('[[[Moduły]]]', [
        {
            name: '[[[Platforma lojalnościowa]]]',
            short: '[[[Platforma]]]',
            icon: 'fa-brands fa-galactic-senate',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Md',
            children: [
                {
                    name: '[[[Opis Usługi]]]',
                    icon: 'far fa-fw fa-star',
                    route: 'md-programs',
                    auth: { all: ['ProgramsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie opisu usługi]]]',
                            route: 'md-programs-add',
                            auth: { all: ['ProgramsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja opisu usługi]]]',
                            route: 'md-programs-edit',
                            auth: { all: ['ProgramsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Punkty użytkowników]]]',
                    icon: 'fa-solid fa-coins',
                    auth: { all: ['UserPointsPermissions@View'], any: [] },
                    route: 'md-user-points',
                    children: [
                        {
                            name: '[[[Dodanie punktów]]]',
                            route: 'md-user-points-add',
                            auth: { all: [], any: ['UserPointsPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja punktów]]]',
                            route: 'md-user-points-edit',
                            auth: { all: [], any: ['UserPointsPermissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Poziomy]]]',
                    icon: 'fa-solid fa-signal',
                    auth: { all: ['LevelsPermissions@View'], any: [] },
                    route: 'md-levels',
                    children: [
                        {
                            name: '[[[Dodanie poziomów]]]',
                            route: 'md-levels-add',
                            auth: { all: [], any: ['LevelsPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja poziomów]]]',
                            route: 'md-levels-edit',
                            auth: { all: [], any: ['LevelsPermissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Importy danych]]]',
                    icon: 'far fa-fw fa-solid fa-upload',
                    auth: { all: ['DataImportsPermissions@View'], any: [] },
                    route: 'md-data-imports',
                    children: [
                        {
                            name: '[[[Dodanie importu]]]',
                            route: 'md-data-imports-add',
                            auth: { all: [], any: ['DataImportsPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Logi importu]]]',
                            route: 'md-data-imports-logs',
                            auth: { all: [], any: ['DataImportsPermissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Quizy]]]',
                    icon: 'far fa-fw fa-solid fa-square-poll-horizontal',
                    auth: { all: ['QuizzesPermissions@View'], any: [] },
                    route: 'md-quizzes',
                    children: [
                        {
                            name: '[[[Dodanie quizu]]]',
                            route: 'md-quizzes-add',
                            auth: { all: [], any: ['QuizzesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja quizu]]]',
                            route: 'md-quizzes-edit',
                            auth: { all: [], any: ['QuizzesPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Wyniki]]]',
                            route: 'md-quizzes-results',
                            auth: { all: ['QuizzesPermissions@ViewResults'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Podejście]]]',
                            route: 'md-quizzes-result',
                            auth: { all: ['QuizzesPermissions@ViewResults'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Pytania]]]',
                            route: 'md-quizzes-questions',
                            auth: { all: ['QuizzesPermissions@ViewQuestions'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie pytania]]]',
                            route: 'md-quizzes-question-add',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja pytania]]]',
                            route: 'md-quizzes-questions-edit',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie pytania]]]',
                            route: 'md-quizzes-questions-add',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie teorii]]]',
                            route: 'md-quizzes-theory-add',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja teorii]]]',
                            route: 'md-quizzes-theory-edit',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Sklepy]]]',
                    icon: 'fa-solid fa-store',
                    route: 'md-companies',
                    auth: { all: ['CompaniesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie sklepu]]]',
                            route: 'md-companies-add',
                            auth: { all: ['CompaniesPermissions@View'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Szczegóły sklepu]]]',
                            route: 'md-companies-edit',
                            auth: { all: ['CompaniesPermissions@View'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Transakcje]]]',
                    icon: 'fa-solid fa-money-bill-transfer',
                    route: 'md-sale-reports',
                    auth: { all: ['SaleReportsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie transakcji]]]',
                            route: 'md-sale-reports-add',
                            auth: { all: ['SaleReportsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja transakcji]]]',
                            route: 'md-sale-reports-edit',
                            auth: { all: ['SaleReportsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Produkty]]]',
                    icon: 'fa-solid fa-box',
                    route: 'md-products',
                    auth: { all: ['ProductsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie produktu]]]',
                            route: 'md-products-add',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja produktu]]]',
                            route: 'md-products-edit',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie]]]',
                    icon: 'fa-solid fa-layer-group',
                    route: 'md-program-categories',
                    auth: { all: ['ProgramCategoriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kategorii]]]',
                            route: 'md-program-categories-add',
                            auth: { all: ['ProgramCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kategorii]]]',
                            route: 'md-program-categories-edit',
                            auth: { all: ['ProgramCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kody promocyjne]]]',
                    icon: 'far fa-fw fa-ticket',
                    auth: { all: ['PromotionalCodesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Zestawy kodów]]]',
                            route: 'md-promotional-code-sets',
                            auth: { all: [], any: ['PromotionalCodesPermissions@View'] }
                        },
                        {
                            name: '[[[Dodanie zestawu kodów]]]',
                            route: 'md-promotional-code-sets-add',
                            auth: { all: [], any: ['PromotionalCodesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja zestawu kodów]]]',
                            route: 'md-promotional-code-sets-edit',
                            auth: { all: [], any: ['PromotionalCodesPermissions@Edit'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Promocje]]]',
                    icon: 'fa-solid fa-percent',
                    route: 'md-promotions',
                    auth: { all: [], any: ['PromotionsPermissions@View'] },
                    children: [
                        {
                            name: '[[[Dodanie promocji]]]',
                            route: 'md-promotions-add',
                            auth: { all: [], any: ['PromotionsPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja promocji]]]',
                            route: 'md-promotions-edit',
                            auth: { all: [], any: ['PromotionsPermissions@Edit'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Grupy dynamiczne]]]',
                    icon: 'fas fa-people-group',
                    route: 'md-dynamic-groups',
                    auth: { all: ['DynamicGroupsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie grupy dynamicznej]]]',
                            route: 'md-dynamic-groups-add',
                            auth: { all: [], any: ['DynamicGroupsPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja grupy dynamicznej]]]',
                            route: 'md-dynamic-groups-edit',
                            auth: { all: [], any: ['DynamicGroupsPermissions@Edit'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Szkolenia]]]',
                    icon: 'far fa-fw fa-solid fa-square-poll-horizontal',
                    auth: { all: ['CoursesPermissions@View'], any: [] },
                    route: 'md-courses',
                    children: [
                        {
                            name: '[[[Dodanie szkolenia]]]',
                            route: 'md-courses-add',
                            auth: { all: [], any: ['CoursesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Konfiguracja]]]',
                            route: 'md-courses-configuration',
                            auth: { all: [], any: ['CoursesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja szkolenia]]]',
                            route: 'md-courses-edit',
                            auth: { all: [], any: ['CoursesPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Tematy]]]',
                            route: 'md-course-subjects',
                            auth: { all: [], any: ['CourseSubjectsPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Dodaj temat]]]',
                            route: 'md-course-subjects-add',
                            auth: { all: [], any: ['CourseSubjectsPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja tematu]]]',
                            route: 'md-course-subjects-edit',
                            auth: { all: [], any: ['CourseSubjectsPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Moduły]]]',
                            route: 'md-course-modules',
                            auth: { all: [], any: ['CourseModulesPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Dodaj moduł]]]',
                            route: 'md-course-modules-add',
                            auth: { all: [], any: ['CourseModulesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja modułu]]]',
                            route: 'md-course-modules-edit',
                            auth: { all: [], any: ['CourseModulesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Wyniki]]]',
                            route: 'md-course-modules-results',
                            auth: { all: [], any: ['CourseModulesPermissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Paczki SCORM]]]',
                    icon: 'fas fa-fw fa-book-open',
                    auth: { all: ['ScormPackagesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista paczek SCORM]]]',
                            route: 'md-scorm-scormpackages',
                            icon: 'fas fa-fw fa-grip-vertical',
                            auth: { all: ['ScormPackagesPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie paczki SCORM]]]',
                                    route: 'md-scorm-scormpackages-add',
                                    auth: { all: ['ScormPackagesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja paczek SCORM]]]',
                                    route: 'md-scorm-scormpackages-edit',
                                    auth: { all: ['ScormPackagesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Raporty Import]]]',
                    icon: 'fa-solid fa-file-csv',
                    route: 'md-import-reports',
                    namespace: 'Ideo.Core.Common.Application.Permissions.Core',
                    auth: { all: ['UsersPermissions@ExportAndImport'], any: [] }
                }
            ]
        },
        {
            name: '[[[Kampanie]]]',
            short: '[[[Kampanie]]]',
            icon: 'fa-regular fa-envelope',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Md',
            children: [
                {
                    name: '[[[Kampanie Email]]]',
                    route: 'md-campaigns-email',
                    icon: 'fa-solid fa-at',
                    auth: { all: ['EmailCampaignsPermissions@View'], any: [] },
                    visible: true,
                    children: [
                        {
                            name: '[[[Dodanie kampanii Email]]]',
                            route: 'md-campaigns-email-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja kampanii Email]]]',
                            route: 'md-campaigns-email-edit',
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kampanie SMS]]]',
                    route: 'md-campaigns-sms',
                    icon: 'fa-solid fa-comment-sms',
                    auth: { all: ['SmsCampaignsPermissions@View'], any: [] },
                    visible: true,
                    children: [
                        {
                            name: '[[[Dodanie kampanii SMS]]]',
                            route: 'md-campaigns-sms-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja kampanii SMS]]]',
                            route: 'md-campaigns-sms-edit',
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);
};
